module.exports = __webpack_public_path__ + "static/media/relatorio.f41ff9f5.png";